// extracted by mini-css-extract-plugin
export default {"wrapper":"Circular_wrapper__Gowmz","RotateLeft":"Circular_RotateLeft__FZOQC","insideCircular":"Circular_insideCircular__P+XIS","RotateRight":"Circular_RotateRight__B3JzI"};